module.exports = __webpack_public_path__ + "static/media/reviews@2x.68011cf3.png";